// extracted by mini-css-extract-plugin
module.exports = {"Background":"OrderHistoryPage_Background__yrV45","Features":"OrderHistoryPage_Features__lk6f0","wishListHead":"OrderHistoryPage_wishListHead__2gXBh"};